import { render, staticRenderFns } from "./SourceType.vue?vue&type=template&id=2bb5f555"
import script from "./SourceType.vue?vue&type=script&lang=js"
export * from "./SourceType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports